var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoundedNumber2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 21.2113V24H9.64641V21.7944L16.302 15.1014C17.0522 14.3408 17.5549 13.6817 17.8103 13.1239C18.0816 12.5493 18.2173 11.9831 18.2173 11.4254C18.2173 10.5972 17.954 9.96338 17.4273 9.52394C16.9006 9.08451 16.1265 8.86479 15.105 8.86479C13.3972 8.86479 12.0884 9.48169 11.1786 10.7155L9 8.94084C9.65439 8.01127 10.5322 7.29296 11.6335 6.78592C12.7508 6.26197 13.9957 6 15.3683 6C17.1878 6 18.6403 6.45634 19.7256 7.36901C20.8109 8.28169 21.3536 9.52394 21.3536 11.0958C21.3536 12.0592 21.1621 12.9634 20.779 13.8085C20.3959 14.6535 19.6618 15.6169 18.5764 16.6986L14.0994 21.2113H22Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedNumber2);
export default __webpack_public_path__ + "static/media/rounded-number-2.d450211dd4c1e2eeca3becc4a84c4d86.svg";
export { ForwardRef as ReactComponent };